import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsAnalyticsDataViewListEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-assets-analytics-data-view-list-entrypoint" */ './index.tsx'
		).then((module) => module.AssetsAnalyticsDataViewListPage),
	),
	getPreloadProps: () => ({}),
});
